// extracted by mini-css-extract-plugin
export default {"sectionControls":"SectionControls_sectionControls__Wyg-t","button":"SectionControls_button__-lbDF","sectionOverflow":"SectionControls_sectionOverflow__1XNg-"};